export default {
    driverStatusLogCreateEdit_editTitle: "Update Driver Time Card",
    driverStatusLogCreateEdit_createTitle: "New Driver Time Card",
    driverStatusLogCreateEdit_action: "Action",
    driverStatusLogCreateEdit_datetime: "Date and time",
    driverStatusLogCreateEdit_success: "Success",
    driverStatusLogCreateEdit_successMessage: "Time card saved",
    driverStatusLogCreateEdit_invalidDriverStatus: `Invalid driver action, please validate the order of the actions, repeated actions in line is not allowed, needs to start in "Clock In" and finishes in "Clock Out", you can't' add actions between "Meal Break" actions` ,
    driverStatusLogCreateEdit_invalidDriverStatusDetail: "or please check and correct the data for the record of: _DATE_",
}